<template>
  <v-row>
    <v-col>
      <v-simple-table>
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>終了日</th>
            <th>期限切れ間近通知</th>
            <th>期限切れ通知</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="transport in manifestTransports"
            :key="transport.section_no"
          >
            <th>
              <span class="label-block">
                <span v-if="transport.section_no === 1">運搬</span>
              </span>&emsp;区間{{ transport.section_no }}
            </th>
            <!-- 終了報告通知 -->
            <td>
              <span v-if="transport.id !== null">
                {{ transport.transport_end_report_time | unix_date_format }}
              </span>
              <span v-else>-</span>
            </td>
            <!-- /終了報告通知 -->
            <!-- 期限切れ間近通知 -->
            <td>
              <span>{{ transport.transport_end_report_near_time | unix_datetime_format }}</span>
            </td>
            <!-- /期限切れ間近通知 -->
            <!-- 期限切れ通知 -->
            <td>
              <span>{{ transport.transport_end_report_expired_time | unix_datetime_format }}</span>
            </td>
          <!-- /期限切れ通知 -->
          </tr>
          <tr>
            <th>
              中間処分
            </th>
            <!-- 終了報告通知 -->
            <td>
              {{ disposalEndMiddle.transport_end_report }}
            </td>
            <!-- /終了報告通知 -->
            <!-- 期限切れ間近通知 -->
            <td>
              {{ disposalEndMiddle.transport_end_report_near }}
            </td>
            <!-- /期限切れ間近通知 -->
            <!-- 期限切れ通知 -->
            <td>
              {{ disposalEndMiddle.transport_end_report_expired }}
            </td>
          <!-- /期限切れ通知 -->
          </tr>
          <tr>
            <th>
              最終処分
            </th>
            <td>
              {{ finalDisposalEnd.transport_end_report }}
            </td>
            <td>
              {{ finalDisposalEnd.transport_end_report_near }}
            </td>
            <td>
              {{ finalDisposalEnd.transport_end_report_expired }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DisposalFlowManifestTransport',
  components: {},
  mixins: [],
  props: {
    /**
     * @param {Object[]} manifestTransports - 運搬詳細
     * @param {number} manifestTransports[].section_no - 区間番号
     * @param {number} manifestTransports[].transport_end_report_time - 終了報告通知
     * @param {number} manifestTransports[].transport_end_report_near_time - 期限切れ間近通知
     * @param {number} manifestTransports[].transport_end_report_expired_time - 期限切れ通知
     */
    manifestTransports: {
      type: Array,
      default: () => []
    },
    /**
     * @param {Object} disposalEndMiddle - 中間処分
     * @param {string} disposalEndMiddle.transport_end_report - 終了報告通知
     * @param {string} disposalEndMiddle.transport_end_report_near - 期限切れ間近通知
     * @param {string} disposalEndMiddle.transport_end_report_expired - 期限切れ通知
     */
    disposalEndMiddle: {
      type: Object,
      default: () => {}
    },
    /**
     * @param {Object} finalDisposalEnd - 最終処分
     * @param {string} finalDisposalEnd.transport_end_report - 終了報告通知
     * @param {string} finalDisposalEnd.transport_end_report_near - 期限切れ間近通知
     * @param {string} finalDisposalEnd.transport_end_report_expired - 期限切れ通知
     */
    finalDisposalEnd: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>
<style scoped lang="scss">
span.label-block { display: inline-block; width: 40px; }
</style>
